import React, { Component } from 'react';
import {
  CircularProgress,
  Checkbox,
  RaisedButton,
  FontIcon,
  FlatButton,
} from 'material-ui';
import { connect } from 'react-redux';
import RateFormatSelection from '../settings/mySettings/rate-format-selection';

const ErrorMessage = ({ retryFn, onRequestClose }) => (
  <div>
    Could not generate the report<br /><a href="javascript:void(0)" onClick={onRequestClose} >cancel</a>, <a href="javascript:void(0);" onClick={() => { retryFn(); }}>retry</a>
     &nbsp;or <a href="javascript:void(0);" onClick={() => { window.Intercom('show'); }}>contact support.</a>
  </div>
);


class DownloadPopover extends Component {
  constructor() {
    super();
  }
  componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      if (window.location.href.indexOf('assets-landing') === -1 &&(localStorage.getItem('doNotShowRateFormatPop') === 'true'
        || localStorage.getItem('doNotShowRateFormatPop') === true
      )) {
        this.props.download({});
      }
    }
  }

  render() {
    const {
      download,
      downloadedCount,
      error,
      loading,
      onRequestClose,
      open,
      success,
      updateProps,
      validLengthForBulkDownload,
      wouldYouAcceptDialog,
      acceptRates,
      retryFn,
      downloadUrl,
      contractIds,
      templateIds,
      templates,
      alContractIds = [],
      downloadRateFormat,
    } = this.props;
    const multi = (() => {
      // if (!isAdmin) return false; // lock down to only admins
      if (templates && templates.length > 1) return true;
      if (contractIds && contractIds.length > 1) return true;
      if (templateIds && templateIds.length > 1) return true;
      return false;
    })();
    const updateDownloadType = type => {
      updateProps({ downloadRateFormat: type });
      if (localStorage) localStorage.setItem('rateFormat', type);
    };
    const onCheck = (_, checked) => localStorage.setItem('doNotShowRateFormatPop', checked);
    const downloadAllInOne = () => {
      updateProps({ downloadRateFormat: 'quickview_summarized_singlefile' });
      download();
    };
    return (
      <div
        style={{
          display: open ? 'flex' : 'none',
          height: '100%',
          width: '100%',
          position: 'fixed',
          zIndex: 15,
          top: 0,
          left: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.67)',
          overflow: 'hidden',
          transition: '0.5s',
          textAlign: 'center',
          alignItems: 'center',
        }}
        data-cy="download-pop-over"
      >
        <div
          style={{
            maxWidth: '1000px',
            background: '#fff',
            margin: '80px auto',
            borderRadius: '5px',
          }}
        >
          {
            (() => {
              if (loading || error) {
                return (
                  <div
                    style={{
                      textAlign: 'center',
                      height: '200px',
                      width: '500px',
                      paddingTop: '48px',
                    }}
                  >
                    <CircularProgress />
                    <br />
                    <br />
                    {error ?
                      <ErrorMessage retryFn={retryFn} onRequestClose={onRequestClose} />
                        : `Generating File ${validLengthForBulkDownload ? `${downloadedCount}/${validLengthForBulkDownload}` : ''}...`
                    }
                  </div>
                );
              }
              if (wouldYouAcceptDialog) {
                return (
                  <div
                    style={{
                      textAlign: 'center',
                      height: success && validLengthForBulkDownload ? '300px' : '250px',
                      width: '500px'
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', padding: '24px 24px 0' }}>
                      <FontIcon
                        className="tc-icon-close"
                        color="rgba(0, 0, 0, 0.84)"
                        style={{ fontSize: '32px', cursor: 'pointer' }}
                        onClick={onRequestClose}
                      />
                    </div>
                    {
                      Boolean(success && validLengthForBulkDownload) && (<div style={{ margin: '16px auto', fontSize: '16px' }}>
                        {`${validLengthForBulkDownload} files have been downloaded!`}
                      </div>)
                    }
                    <h4>Would you like to accept these rates?</h4>
                    <div className="flex-center" style={{ margin: '48px auto 16px', width: '200px' }}>
                      <RaisedButton
                        primary
                        label="No"
                        onClick={onRequestClose}
                      />&nbsp;&nbsp;&nbsp;
                      <RaisedButton
                        secondary
                        label="Yes"
                        onClick={acceptRates}
                      />
                    </div>
                  </div>
                );
              }
              if (success) {
                return (
                  <div
                    style={{
                      textAlign: 'center',
                      height: '280px',
                      width: '500px',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', padding: '24px 24px 0' }}>
                      <FontIcon
                        className="tc-icon-close"
                        color="rgba(0, 0, 0, 0.84)"
                        style={{ fontSize: '32px', cursor: 'pointer' }}
                        onClick={onRequestClose}
                      />
                    </div>
                    <div style={{ fontSize: '18px' }}>
                    File(s) were successfully generated!!
                    </div>
                    (If your download doesn't start immediately, <br /><a href={downloadUrl} target="_blank" rel="noreferrer" style={{ color: '#00bcd4' }}>click here</a> to download.)
                    <br />
                    <FontIcon
                      color="green"
                      className="tc-icon-check_circle"
                      style={{ fontSize: '56px', marginTop: '16px' }}
                    />
                    <br />
                    <br />
                    <RaisedButton
                      label="OK"
                      secondary
                      onClick={onRequestClose}
                    />
                  </div>
                );
              }
              return (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    textAlign: 'center',
                    width: '1000px',
                    height: '550px',
                    overflowY: 'scroll',
                    padding: '32px',
                  }}
                >
                  <h4>Choose your rate format</h4>
                  <RateFormatSelection
                    updateDownloadType={updateDownloadType}
                    multi={multi}
                    downloadType={downloadRateFormat}
                  />
                  <div style={{ marginTop: '32px' }} className="flex-tc-sb">
                    <div style={{ width: '60%', textAlign: 'left' }}>
                      {
                        alContractIds && alContractIds.length > 1 && (
                          <FlatButton
                            label="Download All in a Single Excel File"
                            style={{ border: '1px solid #00bcd4' }}
                            secondary
                            onClick={downloadAllInOne}
                            disabled={loading}
                          />
                        )
                      }
                      {
                        window.location.href.indexOf('assets-landing') === -1 && (
                          <Checkbox
                            label="Save my preference and do not show this preview again"
                            defaultChecked={
                              localStorage.getItem('doNotShowRateFormatPop') === 'true'
                              || localStorage.getItem('doNotShowRateFormatPop') === true
                            }
                            onCheck={onCheck}
                          />
                        )
                      }
                    </div>
                    <div className="flex-center">
                      <RaisedButton data-cy="cancel-download" label="Cancel" primary onTouchTap={onRequestClose} disabled={loading} />
                      &nbsp;&nbsp;
                      <RaisedButton
                        label="Download"
                        secondary
                        onTouchTap={download}
                        disabled={loading}
                        data-cy="download"
                      />
                    </div>
                  </div>
                </div>
              );
            })()
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ contracting, user }) => ({
  ...contracting.downloadDocs,
  isAdmin: user ? user.get('isAnAdmin') : false,
});
export default connect(
  mapStateToProps,
  {
    updateProps: payload => ({ type: '[contracting-download]UPDATE_PROPS', payload }),
    onRequestClose: () => ({ type: '[contracting-download]CLOSE_DOWNLOAD_POPOVER' }),
    download: payload => ({ type: '[contracting-download]DOWLOAD_CONTRACTING_DOCS', payload }),
    acceptRates: () => ({ type: '[contracting-download]ACCEPT_RATES' }),
    downloadXls: payload => ({ type: '[contracting-download]EXPORT_EXCEL', payload }),
    retryFn: () => ({ type: '[contracting-download] downloadGroup_RETRY' }),
  },
)(DownloadPopover);



// WEBPACK FOOTER //
// ./src/app/components/containers/downloadPopover.jsx